import {copyToClipboard} from '@yandex-delivery/utils'
import {useState} from 'react'

function useCopyOnClick(timeout = 3000) {
  const [copied, setCopied] = useState(false)
  return {
    copied,
    onCopyClick: (value?: string | null) => {
      setCopied(true)
      setTimeout(() => setCopied(false), timeout)
      if (value) {
        try {
          copyToClipboard(value)
        } catch {
          // copyToClipboard может упасть в старых браузерах, глушим ошибку
        }
      }
    },
  }
}

export default useCopyOnClick
